import type { HotelI18nInput } from "@/lib/gql/__generated__/graphql";

import type { HotelSettingsHotelInfoI18nFormModel } from "../../../../type";

type Props = {
	viewModel: HotelSettingsHotelInfoI18nFormModel["ViewModel"];
};

export const viewModelToInput = ({ viewModel }: Props): HotelI18nInput => {
	const input: HotelI18nInput = {
		companyID: viewModel.companyID,
		hotelID: viewModel.hotelID,
		lang: viewModel.lang,

		address: viewModel.address
			? {
					city: viewModel.address.city?.value,
					nationality: viewModel.address.nationality?.value,
					postalCode: viewModel.address.postalCode?.value,
					state: viewModel.address.state?.value,
					pref: viewModel.address.pref?.value,
					other: viewModel.address.other?.value,
					town: viewModel.address.town?.value,
				}
			: undefined,
		catchCopy: viewModel.catchCopy?.value,
		name: viewModel.name?.value,
	} satisfies HotelI18nInput;

	return input;
};
